import { AsideCard } from './aside-card'

/**
 * Beside the Background step. Two outcome numbers, then a nudge to answer
 * the level questions honestly — the numbers are what make "answer for
 * where you actually are" land, so they share a card rather than sitting in
 * two.
 *
 * Figures confirmed with Mike (2026-09-10); they are marketing claims, so
 * change them only with the same confirmation.
 */
export function BackgroundAside() {
  return (
    <AsideCard className="flex flex-col gap-4">
      <Stat
        value="97%"
        label="of our clients have an offer within five months"
      />
      <hr className="border-border" />
      <Stat value="83%" label="have one within three months" />
      <hr className="border-border" />
      <p className="text-muted-foreground text-sm">
        Every level from Intern to Principal applies here. Answer for where you
        actually are.
      </p>
    </AsideCard>
  )
}

function Stat({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col gap-1">
      <span className="font-semibold text-2xl leading-none">{value}</span>
      <span className="text-muted-foreground text-sm">{label}</span>
    </div>
  )
}
